export default __webpack_public_path__ + "static/media/YPsitemusicfinalboost.3135fc1c.mp3";